import React from 'react';
import { useQuery } from '@apollo/client';
import query from '../../query';
import { useParams } from 'react-router-dom';
import './Complaint.scss';
import ComplaintReply from './ComplaintReply';

const Complaint = ({ loanId }) => {
  const { id } = useParams();
  const { data, error, refetch, loading } = useQuery(query.getComplaint, {
      variables: { id, loanId },
      fetchPolicy: 'network-only'
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Unable to load complaint.</div>;
  }

  if (!data?.complaint) {
    return <div>Complaint not found.</div>;
  }

  const complaint = data.complaint

  return (
    <div className="complaint-page col-md-12 col-lg-12 col-12 py-2 mb-5">

      <div className="complaint-header">
        <div>
          <h2>Complaint #{complaint.id}</h2>
          <p className="text-theme subject">{complaint.subject}</p>
          <p><span className="font-weight-bold">Created by: </span>{complaint.createdBy}</p>
          <p><span className="font-weight-bold">Created at: </span>{complaint.createdAt}</p>
        </div>

        <span className={`status ${complaint.status}`}>
          {complaint.status}
        </span>
      </div>

      <div className="messages">
        {complaint.messages && complaint.messages.map((message) => (
          <div className="message-card" key={message.id}>
            <div className="message-header">
              <div>
                <div className="user">
                  {message.userName}
                </div>

                <div className="date">
                  {message.createdAt}
                </div>
              </div>
            </div>

            <div className="message-body">
              {message.description}
            </div>

            {message.attachments.length > 0 && (
              <div className="attachments">
                <div className="attachments-title">
                  Attachments
                </div>

                {message.attachments.map(file => (
                  <a
                    key={file.id}
                    href={file.downloadUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="attachment"
                  >
                    <i className="fa fa-paperclip mr-2" />
                    {file.fileName}
                  </a>

                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <ComplaintReply
        complaintId={complaint.id}
        onSuccess={refetch}
      />

    </div>
  );
};

export default Complaint;
